import React from "react";
import ProjectsDropdown from "./ProjectsDropdown";
import ProfilePopup from "./ProfilePopup";
import withAccount from "../utils/withAccount";
import withProfile from "../utils/withProfile";
import { getUserAvatarUrl } from "../firebase/storage";
import IconButton from "./IconButton";
import HelpPanel from "./HelpPanel";

class Header extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      showProfilePopup: false,
      showHelpCenter: false,
      avatar: null
    };
  }

  componentDidMount() {
    getUserAvatarUrl(
      this.props.profile.id,
      url => {
        this.setState({ avatar: url });
      },
      error => {
        this.setState({ avatar: null });
      }
    );
  }

  render() {
    const { avatar, showHelpCenter } = this.state;

    return (
      <div className="Header">
        <div className="Header-Brand-Panel">
          <a href="/">
            <img alt="" src={require("../media/Freeway-Logo.png")} />
          </a>
        </div>
        <p className="Header-Title">{this.props.title}</p>

        {this.props.showProjectsDropdown ? (
          <ProjectsDropdown
            account={this.props.account}
            clientChangeable={this.props.clientChangeable}
            selectedClientId={this.props.selectedClientId}
            clients={this.props.clients}
          />
        ) : null}

        {this.props.showProfile ? (
          <ProfilePopup
            avatar={avatar}
            profile={this.props.profile}
            show={this.state.showProfilePopup}
            history={this.props.history}
            onClose={() => this.setState({ showProfilePopup: false })}
          />
        ) : null}

        <HelpPanel
          visible={showHelpCenter}
          onClose={() => this.setState({ showHelpCenter: false })}
        />

        <span
          style={this.props.showProjectsDropdown ? {} : { marginLeft: "auto" }}
        >
          <IconButton
            icon="question-circle"
            onClick={() => this.setState({ showHelpCenter: true })}
          />

          {this.props.showProfile ? (
            <img
              alt=""
              className="ProfilePicture"
              src={avatar}
              onClick={() => {
                this.setState({
                  showProfilePopup: true
                });
              }}
            />
          ) : null}
        </span>
      </div>
    );
  }
  1;
}

export default withAccount(withProfile(Header));



// WEBPACK FOOTER //
// ./src/components/Header.js